import React from 'react';

const NusmaProductsSection = ({ 
  onNavigateToDemo = () => {},
  onNavigateToContact = () => {} 
}) => {
  const products = [
    {
      id: 1,
      name: "NUSMA Audit AI",
      description: "Plataforma de auditoría automatizada con IA para ISO 27001",
      features: [
        "Evaluación automática de controles",
        "Generación de reportes en tiempo real",
        "Análisis de brechas de cumplimiento",
        "Dashboard ejecutivo interactivo"
      ],
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      gradient: "from-red-600 to-red-900"
    },
    {
      id: 2,
      name: "NUSMA Compliance Agent",
      description: "Agente virtual especializado en consultoría de cumplimiento normativo",
      features: [
        "Consultas 24/7 sobre normativas",
        "Recomendaciones personalizadas",
        "Base de conocimiento actualizada",
        "Integración con sistemas existentes"
      ],
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
        </svg>
      ),
      gradient: "from-red-700 to-red-900"
    }
  ];

  return (
    <section className="py-20 bg-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Nuestros Productos de IA
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Soluciones innovadoras diseñadas específicamente para automatizar y optimizar 
            los procesos de auditoría y cumplimiento normativo en tu organización.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-gray-900 rounded-3xl p-8 shadow-xl border border-gray-800 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              {/* Product Header */}
              <div className="flex items-center mb-6">
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${product.gradient} flex items-center justify-center text-white shadow-lg`}>
                  {product.icon}
                </div>
                <div className="ml-4">
                  <h3 className="text-2xl font-bold text-white">{product.name}</h3>
                  <p className="text-gray-400 mt-1">{product.description}</p>
                </div>
              </div>

              {/* Features List */}
              <div className="space-y-4 mb-8">
                {product.features.map((feature, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-2 h-2 bg-gradient-to-r from-red-500 to-red-700 rounded-full mr-3"></div>
                    <span className="text-gray-300">{feature}</span>
                  </div>
                ))}
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={onNavigateToDemo}
                  className={`flex-1 bg-gradient-to-r ${product.gradient} text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105`}
                >
                  Ver Demo
                </button>
                <button
                  onClick={onNavigateToContact}
                  className="flex-1 bg-gray-800 text-gray-200 px-6 py-3 rounded-xl font-semibold border border-gray-700 hover:bg-gray-700 transition-all duration-200"
                >
                  Más Info
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-gradient-to-r from-gray-800 to-gray-900 rounded-3xl p-12">
          <h3 className="text-2xl font-bold text-white mb-4">
            ¿Listo para transformar tus auditorías?
          </h3>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
            Únete a más de 500 empresas en Latinoamérica que ya confían en NUSMA 
            para sus procesos de cumplimiento normativo.
          </p>
          <button
            onClick={onNavigateToDemo}
            className="bg-gradient-to-r from-red-600 to-red-900 text-white px-8 py-4 rounded-2xl text-lg font-semibold shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            Solicitar Demo Personalizada
          </button>
        </div>
      </div>
    </section>
  );
};

export default NusmaProductsSection;